module.exports = __webpack_public_path__ + "static/new-friend-title.afa514a0.png";